import { FC } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import AuthenticationEndpoint from '../../../api/endpoint/AuthenticationEndpoint';
import { useNavigate, useLocation } from "react-router";
import { useSession } from '../../context/SessionContext';

interface LogoutProps {
    show: boolean;
    onHide: () => void;
}



export const Logout: FC<LogoutProps> = ({show, onHide}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const redirect = params.get("redirect");

    const {refreshSession} = useSession();

    const onLogout = async() => {
        const logoutResult = await AuthenticationEndpoint.Logout();
        if(!logoutResult || logoutResult.errors.length > 0) {
            console.error("Error logging out.");
        } else {
            onHide();
            if(redirect) {
                setTimeout(() => navigate(redirect), 0);
            } else { 
                setTimeout(() => navigate('/'), 0);
            }
            await refreshSession();
        }
    };

    return(
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="logout-title"
            centered
        >
            <Modal.Header>
                <Modal.Title id="logout-title">Are you sure you want to log out?</Modal.Title>
            </Modal.Header>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Cancel</Button>
                <Button variant="danger" onClick={onLogout}>Log Out</Button>
            </Modal.Footer>
        </Modal>
    )
};